import { render, staticRenderFns } from "./Adx.vue?vue&type=template&id=335aa948&scoped=true&"
import script from "./Adx.vue?vue&type=script&lang=ts&"
export * from "./Adx.vue?vue&type=script&lang=ts&"
import style0 from "./Adx.vue?vue&type=style&index=0&id=335aa948&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335aa948",
  null
  
)

export default component.exports